module.exports = __webpack_public_path__ + "img/The Contemporary Singer.fc0f1b0c.jpg";